var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('iframe',{attrs:{"src":_vm.$route.query.url,"frameborder":"0","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }